import React, { useRef } from "react";
import { Camera, Loader, X } from "lucide-react";
import Modal from "../../../components/common/Modal";
import { useTranslation } from "react-i18next";

const FriendFormModal = ({
  open,
  onClose,
  newIdea,
  setNewIdea,
  handleSubmit,
  loadingSubmit,
  handleImageChange,
  handleRemoveImage,
}) => {
  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  const headerContent = (
    <div>
      <h2 className="tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-2xl tw-font-bold tw-text-transparent">
        {t("singles_inferno.recommend_friend")}
      </h2>
      <p className="tw-mt-2 tw-text-gray-500">
        {t("singles_inferno.recommend_friend_description")}
      </p>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} headerContent={headerContent}>
      <form onSubmit={handleSubmit} className="tw-space-y-8">
        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            {t("singles_inferno.friend_name")}
          </label>
          <input
            type="text"
            required
            placeholder={t("singles_inferno.friend_name_placeholder")}
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
            value={newIdea.name}
            onChange={(e) =>
              setNewIdea({
                ...newIdea,
                name: e.target.value,
              })
            }
          />

          <div className="tw-mt-8">
            <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
              {t("singles_inferno.friend_gender")}
            </label>
            <div className="tw-mt-2 tw-flex tw-gap-4">
              <label className="tw-flex tw-items-center">
                <input
                  type="radio"
                  required
                  name="gender"
                  value="male"
                  checked={newIdea.gender === "male"}
                  onChange={(e) =>
                    setNewIdea({
                      ...newIdea,
                      gender: e.target.value,
                    })
                  }
                  className="tw-mr-2"
                />
                {t("male")}
              </label>
              <label className="tw-flex tw-items-center">
                <input
                  type="radio"
                  required
                  name="gender"
                  value="female"
                  checked={newIdea.gender === "female"}
                  onChange={(e) =>
                    setNewIdea({
                      ...newIdea,
                      gender: e.target.value,
                    })
                  }
                  className="tw-mr-2"
                />
                {t("female")}
              </label>
            </div>
          </div>
        </div>

        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            {t("singles_inferno.friend_contact")}
          </label>
          <div className="tw-mt-2 tw-flex tw-w-full tw-gap-2">
            <input
              type="text"
              required
              placeholder={t("singles_inferno.phone_extension")}
              className="tw-block tw-w-[23%] tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
              value={newIdea.telegram?.split(" ")[0] || ""}
              onChange={(e) =>
                setNewIdea({
                  ...newIdea,
                  telegram: `${e.target.value} ${newIdea.telegram?.split(" ")[1] || ""}`,
                })
              }
            />
            <input
              type="text"
              required
              placeholder={t("singles_inferno.phone_number")}
              className="tw-block tw-w-[77%] tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
              value={newIdea.telegram?.split(" ")[1] || ""}
              onChange={(e) =>
                setNewIdea({
                  ...newIdea,
                  telegram: `${newIdea.telegram?.split(" ")[0] || ""} ${e.target.value}`,
                })
              }
            />
          </div>
        </div>

        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            {t("singles_inferno.friend_charm")}
          </label>
          <textarea
            rows={4}
            placeholder={t("singles_inferno.friend_charm_placeholder")}
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
            value={newIdea.description}
            onChange={(e) =>
              setNewIdea({
                ...newIdea,
                description: e.target.value,
              })
            }
          />
        </div>

        <div className="tw-space-y-4">
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            {t("singles_inferno.upload_photo")}
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            ref={fileInputRef}
            onChange={handleImageChange}
            className="tw-hidden"
          />
          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
            {newIdea.imagePreviews.map((preview, index) => (
              <div key={index} className="tw-relative">
                <img
                  src={preview}
                  alt={`預覽 ${index + 1}`}
                  className="tw-h-48 tw-w-full tw-rounded-xl tw-object-cover"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveImage(index)}
                  className="tw-absolute tw-right-2 tw-top-2 tw-rounded-full tw-bg-white tw-p-1 hover:tw-bg-gray-100"
                >
                  <X className="tw-h-4 tw-w-4 tw-text-gray-500" />
                </button>
              </div>
            ))}
            <div
              onClick={() => fileInputRef.current?.click()}
              className="tw-relative tw-flex tw-h-48 tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-border-2 tw-border-dashed tw-border-gray-300 tw-bg-gray-50 tw-transition-colors hover:tw-bg-gray-100"
            >
              <div className="tw-text-center">
                <Camera className="tw-mx-auto tw-mb-2 tw-h-8 tw-w-8 tw-text-gray-400" />
                <p className="tw-text-sm tw-text-gray-500">{t("singles_inferno.click_upload")}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-flex tw-justify-end tw-space-x-4 tw-pt-4">
          <button
            type="submit"
            disabled={loadingSubmit}
            className="tw-flex tw-items-center tw-space-x-2 tw-rounded-xl tw-bg-gradient-to-r tw-from-[#ff6b6b] tw-to-pink-500 tw-px-8 tw-py-3.5 tw-text-base tw-font-medium tw-text-white tw-shadow-lg tw-transition-all hover:tw-shadow-xl disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
          >
            {loadingSubmit ? (
              <>
                <Loader className="tw-h-5 tw-w-5 tw-animate-spin" />
                <span>{t("singles_inferno.uploading")}</span>
              </>
            ) : (
              <span>{t("singles_inferno.recommend_friend")}</span>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default FriendFormModal;
